import {
    Routes,
    Route,
} from "react-router-dom";
import OtherSettingsPage from "./other-settings.page.component";
import BanksPage from "./banks/banks-page.component";


export default function OthersRoutes() {
    return (
        <Routes>
            <Route path="/" element={<OtherSettingsPage />} />
            <Route path="banks" element={<BanksPage />} />
        </Routes>
    )
}